import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IDesbloqOrdenCalidad} from '../modelos/IDesbloqueoOrdenBalCalidad.js';

@Injectable({
  providedIn: 'root'
})
export class DesbloqueoOrdenBalanzaService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.desbloqueoOrdenBalanza.obtenerTodo
    );
  }

  crear(request: IDesbloqOrdenCalidad) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.desbloqueoOrdenBalanza.crear,
      request
    );
  }

  buscarDesbloqueos(user:any) {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.ordenesBalanza.buscarDesbloqueos + "usuario=" + user
    );
  }

  desbloqueo(request: any) {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.desbloqueoOrdenBalanza.desbloqueo,
      request
    );
  }

  buscarDesbloqueosFiltros(parametros:string) {
    //let url = "http://localhost:8080/balanza-api/v1/api/service/bloqueo-balanza/filtros?"+parametros;
    let url = this.url + this.diccionarioModulo.url.ordenesBalanza.filtrarOrdenesBloqueadas + parametros;

    return this._commom.peticionGetConHeader(url);
  }

}
